import { CSSObject } from "@emotion/react";
import { constants, typographyStyles } from "@newsela/angelou";

const colors = constants.colors;
const core500 = colors.ui.core[500];
const neutral400 = colors.ui.neutral[400];
const white = colors.ui.white[100];

const borderColor = core500;

export const containerStyles: CSSObject = {
  display: "flex",
  flexDirection: "column",
  padding: "16px",
};

export const guideRowsContainer: CSSObject = {
  display: "flex",
  flexDirection: "column",
};

export const topSeparatorStyles: CSSObject = {
  borderBottom: `4px solid ${borderColor}`,
};

export const guideCell: CSSObject = {
  display: "flex",
  alignItems: "center",
  justifyContent: "left",
  padding: "0 8px",
  background: white,
  borderRight: `4px solid ${borderColor}`,

  ":last-of-type": {
    borderRight: "none",
  },
};

export const guideRow: CSSObject = {
  display: "grid",
  gridTemplateColumns: "315px 1fr",
  alignItems: "stretch",
  padding: "6px 0",
  background: white,
  borderBottom: `2px solid ${borderColor}`,
  minHeight: "55px",

  ":last-of-type": {
    borderBottom: "none",
  },
};

export const textareaCss: CSSObject = {
  border: `1px solid ${neutral400}`,
  borderRadius: "8px",
  padding: "8px 12px",
  resize: "none",
  height: "100%",
  overflowY: "hidden",
  width: "100%",
  ...typographyStyles.textMObj,
};
